export default __webpack_public_path__ + "navigation-examples-custom-banner-thumbnail-v1-480-51f1f159776d590e13e81320e838c97f.webp";